import { Link } from "react-router-dom";

export function Home() {
  return (
    <div>
      <section className="relative">
        <div className="max-w-6xl mx-auto container-px py-16 md:py-24 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <p className="uppercase tracking-wider text-xs text-foreground/60">
              Bangkok • Clay Design Studio
            </p>
            <h1 className="display text-4xl md:text-6xl mt-3">
              Warm, hand-formed ceramics with Scandinavian calm
            </h1>
            <p className="mt-4 text-foreground/80 max-w-prose">
              Small-batch objects for daily rituals — vessels, tableware, and sculptural pieces.
              Made slowly in our Bangkok studio.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                className="inline-flex items-center rounded-md bg-primary text-primary-foreground px-4 py-2 text-sm hover:opacity-90"
                to="/gallery"
              >
                View Gallery
              </Link>
              <Link
                className="inline-flex items-center rounded-md bg-secondary text-foreground px-4 py-2 text-sm"
                to="/workshops"
              >
                Workshops
              </Link>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden border border-border bg-card">
            <img
              src="https://storage.stardeck.ai/images/b42dc500-6f03-4a7c-828e-cd172a8cf9f8.jpg"
              alt="Mano Studio ceramic vessels in warm cream palette"
              className="w-full h-full object-cover"
            />
            <p className="p-3 text-xs text-foreground/70">Photo: Mano Studio</p>
          </div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto container-px py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Feature title="Small-batch" text="Each piece is shaped, glazed, and finished by hand." />
          <Feature title="Natural tones" text="A palette of cream, terracotta, and sage." />
          <Feature title="Made in Bangkok" text="Crafted locally with global sensibility." />
        </div>
      </section>

      <section className="max-w-6xl mx-auto container-px py-6">
        <div className="rounded-2xl bg-gradient-to-r from-secondary/60 via-background to-secondary/60 border border-border p-8 md:p-10 flex items-center justify-between gap-6">
          <div>
            <h2 className="display text-2xl">Join a weekend workshop</h2>
            <p className="text-foreground/70 mt-1">
              All levels welcome. Materials and firing included.
            </p>
          </div>
          <Link
            to="/workshops"
            className="shrink-0 inline-flex items-center rounded-md bg-primary text-primary-foreground px-4 py-2 text-sm hover:opacity-90"
          >
            Reserve
          </Link>
        </div>
      </section>

      <section className="max-w-6xl mx-auto container-px py-16">
        <h2 className="display text-2xl mb-6">Selected Works</h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {[
            "https://images.pexels.com/photos/5741875/pexels-photo-5741875.jpeg",
            "https://images.pexels.com/photos/28868030/pexels-photo-28868030.jpeg",
            "https://images.pexels.com/photos/19217225/pexels-photo-19217225.jpeg",
          ].map((src) => (
            <div key={src} className="overflow-hidden rounded-xl border border-border">
              <img
                src={`${src}?auto=compress&cs=tinysrgb&w=1200`}
                alt="Ceramic work"
                className="aspect-[4/5] w-full object-cover"
              />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

function Feature({ title, text }: { title: string; text: string }) {
  return (
    <div className="rounded-xl border border-border bg-card p-6">
      <h3 className="font-medium">{title}</h3>
      <p className="text-foreground/70 text-sm mt-1">{text}</p>
    </div>
  );
}
